<template>
    <div>
        <v-btn 
            @click.native="showDialog=true"
            class="select-service-button"
            style="margin-left:0"
        > 
            <span v-if="selectedPet">
                {{selectedPet.name}}<br>
                <span v-if="selectedPet.microchip">Microchip: {{selectedPet.microchip}}</span>
                <span v-else class="missing-microchip">Microchip mancante!</span>
            </span>
            <span v-else>
                Selezionare...
            </span>
        </v-btn>
        <v-dialog
            v-model="showDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Seleziona animale
                </v-card-title>
                <v-card-text v-if="pets.length>0">
                    <v-text-field
                        v-model="searchedText"
                        placeholder="Cerca..."
                    ></v-text-field>
                    <v-card 
                        class="customer-for-picker"
                        v-for="pet in pets" :key="pet.id" 
                        @click="petClicked(pet)"
                        style="background: #e0e0e0"
                    >
                        <v-card-text>
                            <div class="inline-block" style="max-width: calc(100% - 70px);">
                                {{pet.name}}
                            </div>
                        </v-card-text>
                    </v-card>
                    <div 
                        style="width:100%; text-align:center; font-style:italic;"
                        v-if="pets.length==100"
                    >
                        <br>
                        Vengono mostrati solo i primi 100 risultati.
                        <br>
                    </div>
                </v-card-text>
                <v-card-text v-else>
                    <span style="font-style:italic">Nessun animale registrato per questo cliente!</span>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="showDialog = false"
                    >
                        Annulla
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
const axios = require('axios').default;
export default {
  name: "SelectCustomer",
  props: ["value","customerId"],
  data() {
    return {
        showDialog: false,
        selectedValue: null,
        pets:[],
        maxElements: 100,
        searchedText: ""
    };
  },
  methods: {
    getCustomer(customerId){
        let vm = this;
        axios({
            method: "GET",
            url: vm.$API_BASE_URL + "getCustomer.php?customerId="+customerId,
            headers: {
                'Authentication-Token': window.localStorage.getItem("sogno_at")
            }
        })
        .then(function (response) {
            if (response.status == 200) {
                vm.pets = [];
                vm.pets = response.data.resource.pets;
            } 
            else{
                alert("Si è verificato un errore durante il caricamento");
            }
        })
        .catch(function (error) {
            if(error.response.status==403||error.response.status==401){
                vm.$router.push({name: 'login'});
            }
            else{
                alert("Si è verificato un errore durante il caricamento");
                console.error(error)
            }
        });
    },
    petClicked(service){
        let vm = this;
        vm.selectedValue = service.id;
        vm.showDialog = false;
        vm.$emit("input", vm.selectedValue);
    }
  },
  mounted() {
    let vm = this;
    if(vm.customerId){
        vm.getCustomer(vm.customerId);
    }
  },
  computed:{
    selectedPet(){
        let vm = this;
        return vm.pets.find(pet=>pet.id == vm.selectedValue);
    },
  },
  watch: {
    value: {
      handler: function (newValue) {
        let vm = this;
        vm.selectedValue=newValue;
      },
      immediate: true,
    },
    customerId: {
      handler: function (newValue) {
        let vm = this;
        if(newValue){
            vm.getCustomer(newValue);
        }
      },
      immediate: true,
    },
    
  },
};
</script>

<style>
    .cardbutton .v-btn__content{
        display:block!important;
        text-align: left;
    }
    .cardbutton{
        padding: 30px 20px;
    }
    .v-card.customer-for-picker{
        margin-bottom:5px;
    }
    .select-service-button.v-btn {
        text-align: left;
        padding: 25px 10px 25px 10px;
        text-transform: none;
    }
    .missing-microchip{
        color:red;
        font-weight: 500;
    }
</style>
